import { render, staticRenderFns } from "./CampaignDetailRecordsList.vue?vue&type=template&id=b1c83a0a&scoped=true"
import script from "./CampaignDetailRecordsList.vue?vue&type=script&lang=js"
export * from "./CampaignDetailRecordsList.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailRecordsList.vue?vue&type=style&index=0&id=b1c83a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c83a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
